<template>
    <div class="panel-body mt-4">
        
        <div class="step_choose" v-if="cur_step === 'select_type'">
            <ul class="row imc_box">
                <li class="mt-3 mb-3 col-md-4 col-xs-6 col-lg-3 col-xl-2"
                    v-on:click.prevent.stop="show_agree(item)"
                    v-for="item in declaration_info.allowed_types"
                    :key="item && item.id ? item.id : item">
                    <a href="#" class="bg-primary-500 color-primary-500">
                        <div class="menu_item rounded hover-bg shadow-hover text-center shadow-sm border">
                            <div class="icon">
                                <i class="fal fa fa-file"></i>
                            </div>
                            <div class="content">
                                <h5 class="name">
                                    {{ (item && item.name) ? item.name : item }}
                                </h5>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
        
        <div class="agree" v-if="cur_step === 'agree'">
            <div class="panel-tag mt-2">
                Ця анкета не є перевіркою на доброчесність. Це інструмент захисту вашої репутації.
                Наявність відповіді «ТАК» не означає порушення, це означає необхідність прозорості.
                Будь ласка, дайте відповідь на наступні питання стосовно себе та ваших Пов’язаних осіб
                (чоловік/дружина, діти, батьки, рідні брати/сестри)
            </div>
            
            <div class="mb-5 pb-5 mt-5 pb-5">
                <b-form-radio-group
                    id="btn-radios-1"
                    v-model="agree"
                    button-variant="outline-primary"
                    :options="addon_options"
                    name="radios-btn-default"
                    buttons
                ></b-form-radio-group>
                
                <div class="desclimer mt-2">
                    Я підтверджую достовірність наданих даних та надаю згоду на їх обробку. Я усвідомлюю, що надана мною інформація містить персональні дані. Відповідно до Закону України «Про захист персональних даних», я надаю згоду на обробку цієї інформації з метою врегулювання конфлікту інтересів. Щодо переданих мною персональних даних третіх осіб (Пов’язаних осіб), я підтверджую, що маю законні підстави для передачі такої інформації роботодавцю, і що ці особи повідомлені про таку передачу.
                </div>
            </div>
            
            <div class="next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3 pl-0 ml-0 mt-5">
                <button class="btn btn-lg btn-block btn-success waves-effect waves-themed"
                        :disabled="!agree"
                        v-on:click="show_anketa">
                    <span class="fal fa-download mr-1"></span>
                    Розпочати
                </button>
            </div>
        </div>
        
        <div class="anketa" v-if="cur_step === 'anketa'">
            <b-overlay :show="is_load" rounded="sm" opacity="0.6" spinner-small spinner-variant="primary">
                <div v-if="items && items.length">
                    
                    <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                        <div class="mr-3">
                            <div class="font-weight-bold">Декларування конфлікту інтересів</div>
                            <div class="text-muted small">
                                Відповіді: {{ answeredVisibleCount }} / {{ visibleCount }}
                                <span v-if="visibleCount"> ({{ progressPercent }}%)</span>
                            </div>
                        </div>
                        
                        <div class="d-flex align-items-center">
                            <button class="btn btn-outline-secondary mr-2"
                                    type="button"
                                    @click="toggleAllBlocks">
                                {{ allBlocksOpened ? 'Згорнути блоки' : 'Розгорнути блоки' }}
                            </button>
                        </div>
                    </div>
                    
                    <div v-if="showErrors && !canSubmit" class="alert alert-danger">
                        Перевірте відповіді: усі видимі питання мають бути заповнені, а обов’язкові коментарі — внесені.
                    </div>
                    
                    <div v-for="block in items" :key="block.group_type" class="mb-4">
                        
                        <div class="block-head d-flex align-items-center justify-content-between"
                             @click="toggleBlock(block.group_type)">
                            <h4 class="mb-0">{{ block.group_name }}</h4>
                            <span class="text-muted small">{{ blockProgress(block) }}
                                <i class="fal" :class="isBlockOpen(block.group_type) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </span>
                        </div>
                        
                        <div v-show="isBlockOpen(block.group_type)" class="mt-3">
                            <StepNode
                                v-for="step in block.items"
                                :key="step.id"
                                :node="step"
                                :answers="answers"
                                :yesNoOptions="yesNoOptions"
                                :isVisible="isVisible"
                                :isCommentRequired="isCommentRequired"
                                :showErrors="showErrors"
                                :indexMap="indexMap"
                                @setAnswer="setAnswer"
                                @setComment="setComment"
                            />
                        </div>
                    </div>
                    
                    <div class="mt-4">
                        <b-overlay :show="is_saving">
                            <button class="btn btn-lg btn-block btn-success"
                                    :disabled="!canSubmit"
                                    @click="submitAnketa">
                                Надіслати
                            </button>
                        </b-overlay>
                    </div>
                
                </div>
                
                <div v-else class="text-muted p-3">
                    Немає питань для відображення
                </div>
            </b-overlay>
        </div>
    
    </div>
</template>

<script>
import StepNode from './step/StepNode.vue';

export default {
    name: "declaration",
    components: { StepNode },
    
    data() {
        return {
            is_saving : false,
            cur_step: "select_type",
            agree: false,
            
            items: [],
            is_load: false,
            
            declaration_info: {
                cur_type: "year",
                allowed_types: [],
            },
            answers: {},
            // UI
            openBlocks: {},
            showErrors: false,
        };
    },
    
    mounted() {
        this.loadInfo();
    },
    
    computed: {
        addon_options() {
            return [
                { text: 'Погоджуюсь', value: true },
                { text: 'Не погоджую', value: false }
            ];
        },
        
        yesNoOptions() {
            return [
                { text: 'ТАК', value: true },
                { text: 'НІ', value: false }
            ];
        },
        
        visibleNodes() {
            const out = [];
            const walk = (node) => {
                if (!this.isVisible(node)) return;
                out.push(node);
                if (node.children && node.children.length) node.children.forEach(walk);
            };
            
            (this.items || []).forEach(block => (block.items || []).forEach(walk));
            return out;
        },
        
        visibleCount() {
            return this.visibleNodes.length;
        },
        
        answeredVisibleCount() {
            let c = 0;
            for (const n of this.visibleNodes) {
                const v = this.answers[n.id] ? this.answers[n.id].value : null;
                if (v === true || v === false) c++;
            }
            return c;
        },
        
        progressPercent() {
            if (!this.visibleCount) return 0;
            return Math.round((this.answeredVisibleCount / this.visibleCount) * 100);
        },
        
        canSubmit() {
            return this.validateAllVisible();
        },
        
        indexMap() {
            const map = {};
            let i = 1;
            for (const n of this.visibleNodes) {
                map[n.id] = i++;
            }
            return map;
        },
        
        allBlocksOpened() {
            const keys = (this.items || []).map(b => b.group_type);
            if (!keys.length) return false;
            return keys.every(k => this.openBlocks[k] === true);
        },
    },
    
    methods: {
        
        show_agree(item) {
            this.declaration_info.cur_type = item.id;
            this.cur_step = "agree";
        },
        
        async show_anketa() {
            this.cur_step = "anketa";
            this.is_load = true;
            this.showErrors = false;
            
            try {
                const { data } = await api.get('/declaration/step');
                if (data.status === "operation_success") {
                    this.items = data.data || [];
                    this.initAnswersFromItems();
                    this.initOpenBlocks();
                }
            } catch (err) {
                EventBus.$emit('show_toast', { err: err.message, type: "danger", title: err.name });
            } finally {
                this.is_load = false;
            }
        },
        
        async loadInfo() {
            this.is_load = true;
            try {
                const { data } = await api.get('/declaration/info');
                if (data.status === "operation_success") {
                    this.declaration_info = { ...this.declaration_info, ...data.data };
                }
            } catch (err) {
                EventBus.$emit('show_toast', { err: err.message, type: "danger", title: err.name });
            } finally {
                this.is_load = false;
            }
        },
        
        initOpenBlocks() {
            const next = { ...this.openBlocks };
            (this.items || []).forEach(b => {
                if (typeof next[b.group_type] !== 'boolean') next[b.group_type] = true;
            });
            this.openBlocks = next;
        },
        
        initAnswersFromItems() {
            const all = [];
            const walk = (node) => {
                all.push(node);
                if (node.children && node.children.length) node.children.forEach(walk);
            };
            (this.items || []).forEach(block => (block.items || []).forEach(walk));
            
            const next = { ...this.answers };
            all.forEach(step => {
                if (!next[step.id]) next[step.id] = { value: null, comment: '' };
            });
            this.answers = next;
        },
        
        isVisible(step) {
            if (!step.parent_id) return true;
            const parent = this.answers[step.parent_id];
            return parent && parent.value === true;
        },
        
        isCommentRequired(step) {
            const row = this.answers[step.id];
            const v = row ? row.value : null;
            return step.required_comment === true && v === true;
        },
        
        setAnswer(stepId, value) {
            if (!this.answers[stepId]) {
                this.$set(this.answers, stepId, { value: null, comment: '' });
            }
            this.answers[stepId].value = value;
            
            if (value !== true) this.clearChildren(stepId);
        },
        
        setComment(stepId, comment) {
            if (!this.answers[stepId]) {
                this.$set(this.answers, stepId, { value: null, comment: '' });
            }
            this.answers[stepId].comment = String(comment || '');
        },
        
        clearChildren(parentId) {
            const node = this.findNodeById(parentId);
            if (!node || !node.children || !node.children.length) return;
            
            const next = { ...this.answers };
            const wipe = (n) => {
                next[n.id] = { value: null, comment: '' };
                if (n.children && n.children.length) n.children.forEach(wipe);
            };
            node.children.forEach(wipe);
            this.answers = next;
        },
        
        findNodeById(id) {
            let found = null;
            const walk = (node) => {
                if (node.id === id) found = node;
                if (!found && node.children && node.children.length) node.children.forEach(walk);
            };
            (this.items || []).forEach(b => (b.items || []).forEach(walk));
            return found;
        },
        
        // --- validation ---
        validateAllVisible() {
            const visible = this.visibleNodes;
            
            for (const step of visible) {
                const row = this.answers[step.id] || { value: null, comment: '' };
                const v = row.value;
                
                if (v !== true && v !== false) return false;
                
                if (this.isCommentRequired(step)) {
                    if (!String(row.comment || '').trim()) return false;
                }
            }
            return true;
        },
        
        isBlockOpen(groupType) {
            return this.openBlocks[groupType] === true;
        },
        
        toggleBlock(groupType) {
            this.openBlocks = { ...this.openBlocks, [groupType]: !this.isBlockOpen(groupType) };
        },
        
        toggleAllBlocks() {
            const open = !this.allBlocksOpened;
            const next = { ...this.openBlocks };
            (this.items || []).forEach(b => { next[b.group_type] = open; });
            this.openBlocks = next;
        },
        
        blockProgress(block) {
            const nodes = [];
            const walk = (node) => {
                if (!this.isVisible(node)) return;
                nodes.push(node);
                if (node.children && node.children.length) node.children.forEach(walk);
            };
            (block.items || []).forEach(walk);
            
            const total = nodes.length;
            if (!total) return '0/0';
            
            let answered = 0;
            nodes.forEach(n => {
                const v = this.answers[n.id] ? this.answers[n.id].value : null;
                if (v === true || v === false) answered++;
            });
            
            return `${answered}/${total}`;
        },
        
        async submitAnketa() {
            this.showErrors = true;
            this.is_saving = true;
            
            if (!this.canSubmit) {
                this.is_saving = false;
                EventBus.$emit('show_toast', { err: 'Заповніть усі видимі питання та обов’язкові коментарі', type: "danger", title: 'Помилка' });
                return;
            }
            
            const payload = this.visibleNodes.map(n => ({
                id: n.id,
                answer: this.answers[n.id].value,
                comment: String((this.answers[n.id].comment || '')).trim(),
            }));
            
            
            await api.post('/declaration',{
                "answers" : payload,
                'type' : this.declaration_info.cur_type,
            }).then(({data}) => {
                this.is_saving = false;
                this.is_load = false;
                if (data.status == "operation_success") {
                    window.location.href = '/deklaruvannia-konfliktu-interesiv/stvoryty';
                    EventBus.$emit('show_toast', { err: 'Відправлено', type: "success", title: 'OK' });
                }
            }).catch(err => {
                this.is_saving = false;
                this.is_load = false;
                EventBus.$emit('show_toast', {err:err.message ,type:"danger",title:err.name})
                
            });
            
        },
    },
};
</script>

<style scoped>
.desclimer {
    font-style: italic;
    font-size: 13px;
}

.block-head {
    cursor: pointer;
    padding: 12px 14px;
    border: 1px solid rgba(0,0,0,.08);
    border-radius: 10px;
    background: rgba(0,0,0,.02);
}
</style>